import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import type { Role } from '@/types/shared';

interface RoleGuardProps {
  roles: Role[];
}

/**
 * Route-level RBAC gate, layered inside `ProtectedRoute` (which already guarantees an
 * authenticated user). Per 08-staff-ux.md §1: "any create/edit route directly navigated-to
 * server-side-redirects to /403" — this is the client-side equivalent so a user without the
 * module's write role never even sees the form flash before the real 403 from the API.
 */
export function RoleGuard({ roles }: RoleGuardProps) {
  const { user } = useAuth();

  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}
